/* eslint-disable no-return-assign */
/* eslint-disable @typescript-eslint/no-misused-promises */
import { Flex, Menu, MenuList, Spinner, Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import { FaChevronDown, FaFilePdf, FaDownload, FaFileCsv } from 'react-icons/fa'
import { useNavigate } from 'react-router'
import { itemGestao } from '../..'
import { ButtonCmp } from '../../../../../../components/ButtonCmp'
import { MenuButtonCmp } from '../../../../../../components/MenuButtonCmp'
import { ModalBase } from '../../../../../../components/ModalBase'
import { StyledMenuItem } from '../../../../../../components/NavBar/Components/StyledMenuItem'
import { SearchCmp } from '../../../../../../components/SearchCmp'
import { appApi } from '../../../../../../services/appApi'
import { formatarData } from '../../../../components/TabelaPerfis'
import { GetStatus, VerTodosStatus } from '../../statusAssessment'
import { AutorizarConsultorPrismah } from '../../../../../../Utils/Helper'

interface iModalProps {
  isOpen: boolean
  candidatos: itemGestao[]
  titulo: string
  tipoAcesso: number
  onRequestClose: () => void
  onChangeStatus: (id: string, status: string) => void
  baixarRelatorio: (e: itemGestao, urlpdfRelatorioIndividual: string, tipo: string) => void
  IsLoading?: string
}

export const ModalTabelaAderencia: React.FC<iModalProps> = ({ isOpen, onRequestClose, candidatos, tipoAcesso, onChangeStatus, baixarRelatorio, IsLoading, titulo }) => {
  const nav = useNavigate()
  const [SearchText, setSearchText] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  function GetPermissaoBotoesClaro(): boolean {
    return tipoAcesso === 1 || tipoAcesso === 2
  }

  function onGetCsv(): void {
    setIsLoading(true)

    appApi.post('api/SI/ObterCsv', { list: candidatos }, { responseType: 'blob' })
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `CandidatosComFiltro_${new Date().toLocaleDateString('pt-BR')}_${new Date().toLocaleTimeString('pt-BR')}.csv`)
        document.body.appendChild(link)
        link.click()
        link.remove()
        setIsLoading(false)
      })
      .catch((err) => {
        console.log(err)
        setIsLoading(false)
      })
  }

  return (
    <ModalBase
      isOpen={isOpen}
      onClose={onRequestClose}
      Width='72rem'
    >
      <Flex flexDir={'column'} padding={'0 .5rem 1rem .5rem'}>
        <Flex justifyContent={'space-between'} margin='1.75rem 0rem'>
          <Flex justifyContent={'space-between'}>
            <Text fontSize={'24px'}>Relatórios PRISMAH <strong>- {titulo}</strong></Text>
          </Flex>
          <Flex gap={'1rem'} justifyContent={'end'}>
            <ButtonCmp isLoading={isLoading} leftIcon={<FaFileCsv/>} VarColor='Green2' onClick={() => onGetCsv()}>Baixar CSV</ButtonCmp>
            <SearchCmp
              EnterAction={() => { }}
              OnChange={setSearchText}
              placeholder={'Buscar'}
            />
          </Flex>
        </Flex>
        <Flex direction="column" maxW="72rem" border="1px solid var(--c5)">

          {/* Cabeçalho */}
          <Flex bg="var(--c2)" py=".75rem" px="1.5rem" fontWeight="bold" fontSize="14px" borderBottom="1px solid var(--c5)">
            <Flex flex="2">Candidato</Flex>
            <Flex flex="1" justify="center">Gestor</Flex>
            <Flex flex="1" justify="center">Vaga</Flex>
            <Flex flex="1" justify="center">Nome do BP</Flex>
            <Flex flex="2" justify="center">Informações</Flex>
            <Flex flex="1" justify="center" />
          </Flex>

          {/* Corpo */}
          <Flex direction="column" maxH="85vh" overflowY="auto">
            {candidatos?.filter(e => {
              return SearchText === '' || (e.nome.toLowerCase().includes(SearchText.toLowerCase()) || e.nomeBP.toLowerCase().includes(SearchText.toLowerCase()) || e.gestor.toLowerCase().includes(SearchText.toLowerCase()) || e.email.toLowerCase().includes(SearchText.toLowerCase()) || e.emailGestor.toLowerCase().includes(SearchText.toLowerCase()) || e.nomeCargo.toLowerCase().includes(SearchText.toLowerCase()))
            }).map(e => (
              <Flex key={e.id} py=".75rem" px="1.5rem" borderBottom="1px solid var(--c5)" align="center">
                {/* Coluna: Candidato */}
                <Flex flex="2" direction="column" gap="2px">
                  <Text fontSize="12px" fontWeight="600" color="Gray1">{e.nome}</Text>
                  <Text fontSize="12px" fontWeight="400" color="Gray1" maxW="17rem">{e.email}</Text>
                </Flex>

                {/* Coluna: Gestor */}
                <Flex flex="1" justify="center">
                  <Text fontSize="12px" fontWeight="400" color="Gray1" textAlign="center" maxW="7rem" wordBreak="break-word">
                    {e.gestor}
                  </Text>
                </Flex>

                {/* Coluna: Vaga */}
                <Flex flex="1" justify="center">
                  <Text fontSize="12px" fontWeight="400" color="Gray1" textAlign="center" maxW="9rem" wordBreak="break-word">
                    {e.nomeCargo}
                  </Text>
                </Flex>

                {/* Coluna: BP */}
                <Flex flex="1" justify="center">
                  <Text fontSize="12px" fontWeight="400" color="Gray1" textAlign="center" maxW="9rem" wordBreak="break-word">
                    {e.nomeBP}
                  </Text>
                </Flex>

                {/* Coluna: Informações */}
                <Flex flex="2" direction="column" gap="2px" maxW="12rem">
                  <Text fontSize="12px" color="Gray1">Data de criação: <strong>{formatarData(e.dataCriacao ?? '')}</strong></Text>
                  <Text fontSize="12px" color="Gray1">Data de alteração: <strong>{e.dataAlterado ? formatarData(e.dataAlterado) : '-'}</strong></Text>
                  <Text fontSize="12px" color="Gray1" display="flex" gap=".25rem">Status: {GetStatus(e.status, VerTodosStatus(tipoAcesso))}</Text>
                </Flex>

                {/* Coluna: Ações */}
                <Flex flex="1" justify="center">
                  <Flex direction="column" gap=".625rem" align="center">
                    {(e.status !== 1 && e.status !== 2) && (tipoAcesso === 1 || AutorizarConsultorPrismah() || e.status !== 10) && (GetPermissaoBotoesClaro() || e.status === 4) && (
                      <Menu>
                        <MenuButtonCmp Icon={<FaChevronDown size={8} style={{ marginLeft: '-4px' }} />} VarColor="Green2" width="8rem" small>
                          Opções
                        </MenuButtonCmp>
                        <MenuList bg="white" borderRadius=".5rem" boxShadow="0px 2px 8px rgba(0, 0, 0, 0.25)" border="1px solid var(--c5)">
                          {(tipoAcesso === 1 || AutorizarConsultorPrismah()) && (
                            <StyledMenuItem onClick={() => nav(`/PRISMAH/${e.id}/Editar`)}>Editar relatório</StyledMenuItem>
                          )}
                          {e.status !== 10 && GetPermissaoBotoesClaro() && (
                            <StyledMenuItem onClick={() => onChangeStatus(e.id, '3')}>Ocultar relatório</StyledMenuItem>
                          )}
                          {e.status !== 10 && e.urlpdfRelatorioIndividual && e.urlpdfRelatorioRH && GetPermissaoBotoesClaro() && (
                            <StyledMenuItem onClick={() => onChangeStatus(e.id, '4')}>Liberar relatório</StyledMenuItem>
                          )}
                          {e.status === 10 && (tipoAcesso === 1 || AutorizarConsultorPrismah()) && (
                            <StyledMenuItem onClick={() => onChangeStatus(e.id, '3')}>Liberar para o RH</StyledMenuItem>
                          )}
                          {e.status !== 10 && (tipoAcesso === 1 || AutorizarConsultorPrismah()) && (
                            <StyledMenuItem onClick={() => onChangeStatus(e.id, '10')}>Ocultar para o RH</StyledMenuItem>
                          )}
                          <StyledMenuItem onClick={() => window.location.href = `${process.env.REACT_APP_URL_API}/api/SI/ExportarDadosCSV/${e.id}`}>
                            Baixar recomendações (CSV)
                          </StyledMenuItem>
                          {e.urlDescritivoCargo && (
                            <StyledMenuItem onClick={() => window.location.href = e.urlDescritivoCargo}>Baixar descritivo de cargo</StyledMenuItem>
                          )}
                          {e.urlCurriculo && (
                            <StyledMenuItem onClick={() => window.location.href = e.urlCurriculo}>Baixar currículo</StyledMenuItem>
                          )}
                          {e.urlpiCandidato && (
                            <StyledMenuItem onClick={() => window.location.href = e.urlpiCandidato}>Baixar PI do candidato</StyledMenuItem>
                          )}
                          {e.urlpiDesenvolvimento && (
                            <StyledMenuItem onClick={() => window.location.href = e.urlpiDesenvolvimento ?? ''}>Baixar PI - Quadro de desenvolvimento</StyledMenuItem>
                          )}
                          {e.urlpiGestor && (
                            <StyledMenuItem onClick={() => window.location.href = e.urlpiGestor}>Baixar PI do gestor</StyledMenuItem>
                          )}
                          {e.urlpiRelacionamentoGestor && (
                            <StyledMenuItem onClick={() => window.location.href = e.urlpiRelacionamentoGestor ?? ''}>Baixar PI - Relacionamento com gestor</StyledMenuItem>
                          )}
                        </MenuList>
                      </Menu>
                    )}

                    {(tipoAcesso === 1 || AutorizarConsultorPrismah() || e.status !== 10) && (e.urlpdfRelatorioIndividual && e.urlpdfRelatorioRH) && (
                      <Menu onClose={() => {}}>
                        <MenuButtonCmp LeftIcon={<FaFilePdf size={12} />} VarColor="Rosa" width="8rem" small>
                          Relatórios
                        </MenuButtonCmp>
                        {IsLoading !== e.id
                          ? (
                          <MenuList bg="white" borderRadius=".5rem" boxShadow="0px 2px 8px rgba(0, 0, 0, 0.25)" border="1px solid var(--c5)">
                            <StyledMenuItem onClick={() => baixarRelatorio(e, e.urlpdfRelatorioRH ?? '', 'Assessment')}>
                              <FaDownload size={14} style={{ marginRight: '.375rem' }} />
                              Relatório para o RH
                            </StyledMenuItem>
                            <StyledMenuItem onClick={() => baixarRelatorio(e, e.urlpdfRelatorioRH ?? '', 'Assessment')}>
                              <FaDownload size={14} style={{ marginRight: '.375rem' }} />
                              Relatório para o Gestor
                            </StyledMenuItem>
                            <StyledMenuItem onClick={() => baixarRelatorio(e, e.urlpdfRelatorioIndividual ?? '', 'Individual')}>
                              <FaDownload size={14} style={{ marginRight: '.375rem' }} />
                              Relatório individual
                            </StyledMenuItem>
                          </MenuList>
                            )
                          : (
                          <MenuList>
                            <StyledMenuItem>
                              <Spinner size="sm" mr=".625rem" />
                              Carregando relatórios...
                            </StyledMenuItem>
                          </MenuList>
                            )}
                      </Menu>
                    )}
                  </Flex>
                </Flex>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Flex>
    </ModalBase>
  )
}
